var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.1953 0H6.80467C3.04655 0 0 2.91139 0 6.50277V41.2783C0 44.8697 3.04655 47.7811 6.80467 47.7811H43.1953C46.9534 47.7811 50 44.8697 50 41.2783V6.50277C50 2.91139 46.9534 0 43.1953 0Z",
    fill: "#124729"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6849 10.665C12.6775 10.5652 11.0289 12.1821 11.1307 14.1509C11.2175 15.8362 12.614 17.2059 14.333 17.2917C16.3404 17.3915 17.9891 15.7745 17.8873 13.8058C17.7998 12.1205 16.4033 10.7508 14.6849 10.6657V10.665Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5634 19.5195H11.4546V37.7503H17.5634V19.5195Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.079 19.09C29.7286 19.09 28.0772 20.1897 26.9226 21.5942V19.5196H20.8137V37.7503H26.9226V27.0676C27.0879 24.7725 28.7584 24.1734 29.9438 24.1734C31.1921 24.1734 32.7684 24.7691 32.7684 28.119V37.7496H38.8772V24.9085C38.8772 24.9085 38.6032 19.0894 32.079 19.0894V19.09Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.9513c29f53334e234b92e72aedd0e625.svg";
export { ForwardRef as ReactComponent };